module.exports = __webpack_public_path__ + "static/media/no-recommended.8d9e4287.svg";